import { Component, Input } from "@angular/core"
import { ColorCodeService } from "../../../services/color-code.service"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"

@Component({
    selector: "app-collection-browse-card",
    templateUrl: "./collection-browse-card.component.html",
    styleUrls: ["./collection-browse-card.component.less"],
})
export class CollectionBrowseCardComponent extends CardComponent {
    @Input() public gtmDataCardNumber: number

    constructor(
        protected colorCodeService: ColorCodeService,
        public userService: UserService
    ) {
        super(colorCodeService, userService)
    }
}
